export default __webpack_public_path__ + "static/media/Navigation.b4dd0123.svg";